import type {
  CodeableConcept,
  Practitioner,
  Reference,
  Task,
} from '@medplum/fhirtypes'
import { getNextWorkday } from '#src/dates.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import { StandardTask } from '#src/models/tasks/standard/standardTask.ts'
import { Role } from '#src/roles.ts'

export class ReviewAstranaAuthorizationTask extends StandardTask {
  static defaultRoles = [Role.MA, Role.LVN]

  constructor({
    ...rest
  }: Partial<Omit<Task, 'resourceType'>> & {
    owner?: Reference<Practitioner>
  }) {
    super({
      code: ReviewAstranaAuthorizationTask.code,
      priority: 'urgent',
      ...rest,
    })
    this.title = 'Review External Authorization'
    this.state = 'todo'
    this.dueOn = getNextWorkday().toISOString()
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.REVIEW_EXTERNAL_AUTHORIZATION
  }
}
